import React, { useContext } from "react";
import { CartContext } from "../../layout/Main";
import ReviewItems from "../ReviewItems/ReviewItems";

const Order = () => {
	const [cart, setCart] = useContext(CartContext);

	const handleDeleteItem = (item) => {
		const existItem = cart.filter((product) => product.id !== item.id);

		setCart(existItem);
	};
	let total = 0;
	for (const product of cart) {
		total = total + product.price;
	}
	return (
		<section className="fashion mb-10">
			<div className="container mx-auto">
				<h2 className="text-4xl">This is Order Page {cart?.length}</h2>
				<div className="my-10 flex justify-around">
					<div className="review_items w-5/12 px-20">
						{cart?.map((item) => (
							<ReviewItems
								key={item.id}
								item={item}
								handleDeleteItem={handleDeleteItem}
							></ReviewItems>
						))}
					</div>
					<div className="total-area">
						<div className="card w-96 bg-primary text-primary-content">
							<div className="card-body">
								<h2 className="card-title">Sub Total</h2>
								<p>${total}</p>
							</div>
                            <button className="btn-secondary btn btn-block">
                                Place Order
                            </button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Order;
